<template>
    <qx-pagination class="pagination"
                   v-if="total>0"
                   :pager-count="9"
                   :page-size="pageSize"
                   :page-sizes="pageSizes"
                   @size-change="handleSizeChange"
                   :current-page="curPage"
                   @current-change="handleCurrentChange"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper">
    </qx-pagination>
</template>

<script>
import QxPagination from '@/components/common/qx-pagination'
    export default {
        components: {
            QxPagination
        },
        name: "BasePagination",
        props: {
            endPagination:Boolean,
            curPage:Number,
            pageSize:Number,
            total:Number,
            pageSizes: {
                type: Array,
                default: () => [20, 50, 100]
            }
        },
        data: function () {
            return {

            }
        },
        methods: {
            init: function () {

            },
            doAction: function (param) {
                this.$emit('action', {action:'query',...param});
            },
            handleSizeChange: function (val) {
                if(this.endPagination) {
                    this.doAction({pageSize: val})
                }
                this.$emit('update:pageSize',val)
            },
            handleCurrentChange: function (val) {
                if(this.endPagination) {
                    this.doAction({curPage: val,pageSize:this.pageSize})
                }
                this.$emit('updateCurPage',val)
                this.$emit('update:curPage',val)
            }
        }
    }
</script>

<style scoped>
    .pagination {
        float: right;
        padding: 0px;
    }
</style>
